import { apiClient } from '@/core/apiClient';
import { Animal, AnimalPhoto, AnimalsListParams } from './types';

export const animalsApi = {
  getWithPhotos: async (id: number) => {
    const response = await apiClient.get(`/animals/${id}/with-photos`);
    const body = response.data;
    return body?.data ?? body;
  },
  // Search endpoint with server-side filtering/sorting/pagination
  search: async (query: Record<string, any>) => {
    const response = await apiClient.get('/animals/search', { params: query });
    return response.data; // expected: { data, total, page, pageSize }
  },
  list: async (params: AnimalsListParams) => {
    const response = await apiClient.get('/animals', { params });
    return response.data;
  },

  getById: async (id: number) => {
    // Prefer dedicated endpoint that ensures all photos sorted
    return await animalsApi.getWithPhotos(id);
  },

  create: async (animal: any) => {
    const response = await apiClient.post('/animals', animal);
    const body = response.data;
    return body?.data ?? body;
  },

  update: async (id: number, animal: any) => {
    const response = await apiClient.patch(`/animals/${id}`, animal);
    const body = response.data;
    return body?.data ?? body;
  },

  replace: async (id: number, animal: any) => {
    const response = await apiClient.put(`/animals/${id}`, animal);
    const body = response.data;
    return body?.data ?? body;
  },

  delete: async (id: number) => {
    await apiClient.delete(`/animals/${id}`);
  },

  // Photos
  uploadPhotos: async (animalId: number, files: File[]) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    const response = await apiClient.post(`/animals/${animalId}/photos/upload`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  setPhotoPrimary: async (animalId: number, newPrimaryId: number | string) => {
    await apiClient.post(`/animals/${animalId}/photos/set-primary`, { photoId: Number(newPrimaryId) });
  },

  deleteAllPhotos: async (animalId: number) => {
    await apiClient.delete(`/animals/${animalId}/photos`);
  },

  deletePhoto: async (animalId: number, photoId: number) => {
    await apiClient.delete(`/animals/${animalId}/photos/${photoId}`);
  },

  // Additional colors
  updateColors: async (animalId: number, colorIds: number[]) => {
    const response = await apiClient.put(`/animals/${animalId}/colors`, { color_ids: colorIds });
    const body = response.data;
    return body?.data ?? body;
  },
};
